import type { AgenciesQuery } from '../../graphql/graphql';

type AgencyConnection = AgenciesQuery['agencies'];
type AgencyNode = NonNullable<NonNullable<AgencyConnection['nodes']>[number]>;
type AgencyConnectionWithEdges = AgencyConnection & {
  edges?: Array<{ node?: AgencyNode | null } | null> | null;
};

export const mapAgencyConnectionToNodes = (
  connection: AgencyConnectionWithEdges | null | undefined
): AgencyNode[] => {
  const nodes =
    connection?.nodes ?? connection?.edges?.map(edge => edge?.node) ?? [];

  return nodes.filter((node): node is AgencyNode => Boolean(node));
};
